import { useState } from "react";
import { motion } from "framer-motion";
import Education from "./Education";

const techStack = [
  "Java (backend)",
  "Kotlin & Android",
  "Spring Boot",
  "React / Next.js",
  "Firebase / Cloud",
  "Python (ML)",
];

const ease = [0.22, 1, 0.36, 1];

export default function About() {
  const [bioExpanded, setBioExpanded] = useState(false);

  return (
    <section id="about" className="section-shell border-t-2 border-line py-20 text-ink md:py-28">
      <div className="mx-auto max-w-[100rem] px-4 md:px-8">
        <div className="border-b-2 border-line pb-8">
          <p className="section-kicker">About</p>
          <h2 className="section-heading">
            Curious by<br />default.
          </h2>
        </div>

        <div className="grid border-x-2 border-b-2 border-line lg:grid-cols-[1fr_1fr]">
          <motion.div
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.5, ease }}
            className="border-b-2 border-line p-7 lg:border-b-0 lg:border-r-2"
          >
            <p className="section-kicker">Who I am</p>
            <div className="mt-5 space-y-4 text-sm leading-relaxed text-inksoft md:text-base">
              <p>
                I'm Mehedi, a Computer Science graduate from Dhaka and a full-stack developer. I got into web
                development because I enjoyed turning ideas into things people could actually use. During university, I
                found myself gravitating toward web and Android development, and that interest naturally grew into
                something I wanted to keep building.
              </p>
              <div className={`space-y-4 ${bioExpanded ? "" : "hidden"} md:block`}>
                <p>
                  These days, I build mostly because I genuinely enjoy it. I'll stay up way too late chasing an idea,
                  spend hours tracking down one stubborn bug, and the moment it's finally solved, I'm already thinking
                  about the next project.
                </p>
                <p>
                  For me, coding has always been more than just writing lines of code. It's the process of learning,
                  experimenting, breaking things, fixing them, and slowly turning an idea into something real. That's the
                  part that keeps me coming back every day.
                </p>
              </div>
              <button
                type="button"
                onClick={() => setBioExpanded((v) => !v)}
                aria-expanded={bioExpanded}
                className="font-mono text-[11px] uppercase tracking-[0.2em] text-accent underline-offset-4 hover:underline md:hidden"
              >
                {bioExpanded ? "Show less ↑" : "Read more ↓"}
              </button>
            </div>
          </motion.div>

          <div>
            <Education />
          </div>
        </div>

        <div className="border-x-2 border-b-2 border-line">
          <p className="border-b-2 border-line px-7 py-4 font-mono text-[11px] uppercase tracking-[0.2em] text-inkfaint">
            // core toolkit
          </p>
          <ul className="grid sm:grid-cols-2 lg:grid-cols-3">
            {techStack.map((item) => (
              <li
                key={item}
                className="flex items-center gap-3 border-b-2 border-r-2 border-line px-7 py-4 font-display text-lg uppercase transition-colors hover:bg-accent hover:text-paper"
              >
                <span className="font-mono text-xs text-accent">→</span>
                {item}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
